import React from "react";

import { GatsbyImage } from "gatsby-plugin-image";

import BloccoAcquisto from "../bloccoAcquisto";

import Tooltip from '@mui/material/Tooltip';
import { useTheme } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import useMediaQuery from '@mui/material/useMediaQuery';


const Dettaglio = (props) => {
  const { lingua, data, camicia, immagine, thumb } = props;

  const [open, setOpen] = React.useState(false);

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);


  return (
    <>
      
        <div className="box is-shadowless is-radiusless is-hidden-touch">
          <div className="media mb-4">
            <div className="media-left">
              <Tooltip title="Zoom" placement="left-start">
                <figure className="image is-60x60" onClick={handleOpen} style={{ cursor: "pointer" }}>
                  <GatsbyImage
                    image={thumb.gatsbyImageData}
                    alt={data.nome}
                  />

                </figure>
              </Tooltip>
            </div>
            <div className="media-content">
              <p className="title is-6">{data.nome}</p>
              <p className="subtitle is-7 mb-1">{data.codice}</p>
              <p className="subtitle is-7 is-uppercase">{data.brand}</p>
            </div>
          </div>

          <p className="is-size-7 mb-4">
            {data[`descrizione_${lingua.lang}`]}
          </p>

          <BloccoAcquisto data={data} lingua={lingua} camicia={camicia}  />
        </div>
      

     
      <div className="box is-shadowless is-radiusless pb-1 is-hidden-desktop" style={{position:"fixed",bottom:0,left:0,width:"100%"}}>
            <BloccoAcquisto data={data} lingua={lingua} camicia={camicia}  />
            
      </div>


      <Dialog
        fullScreen={fullScreen}
        open={open}
        onClose={handleClose}
        aria-labelledby="zoom"
        PaperComponent={"div"}
      >
        <DialogTitle >
          <button className="delete is-large" onClick={handleClose} />
        </DialogTitle>
        <DialogContent>
          <GatsbyImage
            image={immagine.gatsbyImageData}
            alt={data.nome}
          />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default Dettaglio;
